module.exports = __webpack_public_path__ + "images/icons_v2/autoship-status-active-bd751aa1.svg";